import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { EntityCommandInformation } from "@seriously-rad/seriouslyrad-framework-core/EntityCommandInformation";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { ObjectHelper } from "@seriously-rad/seriouslyrad-framework-core/Helpers/ObjectHelper";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { PermissionEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { WebApiClientService } from "@seriously-rad/seriouslyrad-framework-core/Server/WebApiClientService";
import { ServiceManager } from "@seriously-rad/seriouslyrad-framework-core/ServiceManager";
import { NAMESPACE } from "./_Namespace";

export type EntityCommandJobScheduleRunNowPropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandJobScheduleRunNowProperties = {
    [name in keyof EntityCommandJobScheduleRunNowPropertyValues]: Property<EntityCommandJobScheduleRunNowPropertyValues[name]>
};

export interface IEntityCommandJobScheduleRunNow extends IEntityCommand, EntityCommandJobScheduleRunNowProperties
{
}

export class EntityCommandJobScheduleRunNow extends EntityCommand implements IEntityCommandJobScheduleRunNow
{
    // #region Static

    public static override classNamespace = NAMESPACE + "EntityCommandJobScheduleRunNow";
    public static override className = "EntityCommandJobScheduleRunNow";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandJobScheduleRunNowPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "Run Now",
                entityName: "JobSchedule",
                key: "RUNNOW",
                permission: PermissionEvaluator.permissionLevels.execute,
                type: EntityCommandTypeEnum.entity,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructor

    constructor(propertyValues?: PartialNullable<EntityCommandJobScheduleRunNowPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override _executeAsync(entityCommandInformation: EntityCommandInformation, value: any)
    {
        return (
            super._executeAsync(entityCommandInformation, value)
                .then(() =>
                {
                    const
                        recordId = entityCommandInformation.getRecordId();

                    if (!recordId)
                        return;

                    return (
                        ServiceManager.getRequired(WebApiClientService)
                            .createApiMethodRequest("DataService", "CallDataService", { id: "463f29c9-a53a-4cff-9fd4-5b5145cd0160", operation: "RunNow", data: ObjectHelper.toJson({ jobScheduleId: recordId }) })
                            .executeAsync()
                    );
                })
        );
    }

    // #endregion

    // #endregion
}

